import instance from "../root.api";

export const getProgressRequest = () =>
  instance.get(`/user-progresses/me`).then((response) => ({ response }));

export const updateProgressRequest = (data) =>
  instance.post(`/user-progresses/me`, data).then((response) => ({ response }));
